module.exports = __webpack_public_path__ + "media/8.fd2039ee.mp3";